var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.9287 3.1225C25.5 5.35 25.5 10 25.5 10C25.5 10 25.5 14.65 24.9287 16.8775C24.6112 18.1088 23.6825 19.0775 22.5062 19.405C20.37 20 13 20 13 20C13 20 5.63375 20 3.49375 19.405C2.3125 19.0725 1.385 18.105 1.07125 16.8775C0.5 14.65 0.5 10 0.5 10C0.5 10 0.5 5.35 1.07125 3.1225C1.38875 1.89125 2.3175 0.9225 3.49375 0.595C5.63375 -2.23517e-07 13 0 13 0C13 0 20.37 -2.23517e-07 22.5062 0.595C23.6875 0.9275 24.615 1.895 24.9287 3.1225ZM10.5 14.375L18 10L10.5 5.625V14.375Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeimg);
export default __webpack_public_path__ + "static/media/youtubeimg.525cb8ef8c3bba3449fff2e319d3253b.svg";
export { ForwardRef as ReactComponent };